import RoutingResult from '../../../components/RoutingResult';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import { useQuery } from '../../../hooks/useQuery';

export default function ConsultResult() {
  const query = useQuery();
  const activeSidebar = query.get('activeSidebar');
  const returnLink = decodeURIComponent(query.get('returnLink')!);
  return (
    <>
      <Sidebar active={activeSidebar!} />
      <Transitions>
        <RoutingResult
          returnLink={returnLink}
          status=''
        />
      </Transitions>
    </>
  );
}
